import { Predicate } from '../types/api/v1/obt/common/policy_info';

export const llfPredicates = [
  Predicate.AIR_MAX_PRICE_MORE_THAN_LLF_VIOLATION_INCLUDING_TAX,
  Predicate.AIR_MAX_PRICE_MORE_THAN_LLF_VIOLATION_EXCLUDING_TAX,
  Predicate.FARE_MORE_THAN_LLF,
];
